module.exports = __webpack_public_path__ + "img/a1.256fb2b1.png";